import { gql } from '@apollo/client'

export default gql`
  subscription GetReadingLiveCallStates($reading_id: uuid!) {
    live_call_state(where: { reading_id: { _eq: $reading_id } }) {
      user_id
      personName
      is_hand_raised
      role
      last_updated
    }
  }
`
